import { render, staticRenderFns } from "./Paralax.vue?vue&type=template&id=2db1d068"
import script from "./Paralax.vue?vue&type=script&lang=js"
export * from "./Paralax.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports